module.exports = __webpack_public_path__ + "img/header_language_black.b79973ae.svg";